import React from 'react';
import { Container, Section } from '../ui/Section';
import { ButtonLink } from '../ui/Button';
import { PhotoFrame } from '../ui/PhotoFrame';
import { DoodleStar, DoodleUnderline } from '../brand/Doodles';
import { galleryPhotos } from '../../data/photos';
const activities = [{
  title: 'Worship & Scripture',
  copy: 'Gather for worship, Bible study, and conversations centered on following Jesus.'
}, {
  title: 'Community & Friendship',
  copy: 'Build meaningful relationships through worship nights, community groups, shared meals, and time together.'
}, {
  title: 'Service & Outreach',
  copy: 'Serve others, reach students across campus, and help make UCF a place where people feel seen and welcomed.'
}, {
  title: 'Missions, Sports & More',
  copy: 'Take part in missions, intramural sports, recreational nights, retreats, and other opportunities throughout the year.'
}];
export function WhoWeAre() {
  return <Section className="bcm-paper overflow-hidden py-16 sm:py-20" labelledBy="who-heading" data-id="element-249" data-mp="38gfz55pbxdb4">
      <Container data-id="element-250" data-mp="348fafkzmshye">
        <div className="grid items-start gap-10 lg:grid-cols-[1fr_0.85fr] lg:gap-14" data-id="element-251" data-mp="399mill5orj5l">
          <div data-id="element-252" data-mp="397a2ldjhniv6">
            {/* The one decorative script accent used on the site. */}
            <p className="font-script text-3xl leading-none text-brand-navy" data-id="element-253" data-mp="3e7ehiz4r05ja">Come as you are</p>
            <h2 id="who-heading" className="mt-4 font-serif text-3xl font-semibold leading-tight text-brand-navy sm:text-[2.6rem]" data-id="element-254" data-mp="3j0qx6jrg91zw">
              A community built around faith, friendship, and purpose
            </h2>
            <DoodleUnderline className="mt-3 h-3 w-44" color="var(--bcm-pink)" data-id="element-255" data-mp="tjm8bk0xgwk" />
            <p className="mt-6 max-w-xl font-sans text-[17px] leading-relaxed text-ink" data-id="element-256" data-mp="5smjh9triitz">
              BCM stands for Baptist Collegiate Ministries, but the community is not exclusively
              Baptist. Students come from different denominations, religious backgrounds, schools,
              and life experiences. Whether you have followed Jesus for years, have questions about
              faith, or are simply looking for community, you are welcome to visit.
            </p>
            <ButtonLink to="/about" variant="primary" className="mt-7" data-id="element-257" data-mp="29hr81mvg87xm">
              Learn More About BCM
            </ButtonLink>
          </div>

          <div className="relative" data-id="element-258" data-mp="24hv3nmiuaehj">
            <DoodleStar className="absolute -left-4 -top-5 h-10 w-10" color="var(--bcm-yellow)" data-id="element-259" data-mp="24l0sd0nk3ecq" />
            <div className="grid grid-cols-2 gap-4" data-id="element-260" data-mp="2ig2t79djqdio">
              <PhotoFrame photo={galleryPhotos[0]} ratio="aspect-[3/4]" rotate="-rotate-2" data-id="element-261" data-mp="2dib5ysnujfkt" />
              <PhotoFrame photo={galleryPhotos[1]} ratio="aspect-[3/4]" rotate="rotate-2" className="mt-8" data-id="element-262" data-mp="2s77869381ydi" />
            </div>
          </div>
        </div>

        <ul className="mt-14 grid gap-8 sm:grid-cols-2 sm:gap-x-10 lg:grid-cols-4" data-id="element-263" data-mp="2nbi7g2fgubfm">
          {activities.map((activity, index) => <li key={activity.title} className="border-t-2 border-brand-navy pt-5" data-id="element-264" data-mp="2x84qqms58ufj" data-mpi={index}>
              <span aria-hidden="true" className={`block h-2.5 w-10 rounded-full ${['bg-brand-yellow', 'bg-brand-pink', 'bg-brand-blue', 'bg-brand-navy'][index % 4]}`} data-id="element-265" data-mp="3fv440ngfj2bc" />
              <h3 className="mt-4 font-display text-xl font-bold leading-snug text-brand-navy" data-id="element-266" data-mp="36uo39lr2m9a6">
                {activity.title}
              </h3>
              <p className="mt-2 font-sans text-[15px] leading-relaxed text-ink" data-id="element-267" data-mp="2x4messut2ouq">{activity.copy}</p>
            </li>)}
        </ul>
      </Container>
    </Section>;
}